import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmConfiguration = ({ model, trim, gtmBodyStyle, availabilityFlag, componentType, action, itemCategory, currentSelection, toBeAdded, toBeRemoved, }) => {
    // Map actions to event names
    const eventMap = {
        confirm: 'configuration_conflict_confirm',
        cancel: 'configuration_conflict_cancel',
        open: 'configuration_conflict',
    };
    // Determine the event using the action
    const event = eventMap[action];
    const gtmPayload = {
        event,
        item_category: itemCategory,
        current_selection: currentSelection,
        to_be_added: toBeAdded,
        to_be_removed: toBeRemoved,
        component_type: componentType,
        model,
        trim,
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmConfiguration;
